<ng-container *ngIf="feedbackType === 'textarea'">
  <user-input-area
    (feedbackTextArea)="onValueChange($event)"
    [placeholderText]="'enter_text_here' | translate"
    [ariaLabel]="'ai_feedback_input_aria' | translate"
  ></user-input-area>
</ng-container>
<ng-container
  *ngIf="
    feedbackStep &&
    feedbackStep.checkbox_options &&
    feedbackStep.checkbox_options.length > 0
  "
>
  <div class="feedback-checkboxes-wrapper" role="group" style="padding: 15px">
    <ng-container
      *ngFor="let option of feedbackStep.checkbox_options; let first = first"
    >
      <mat-checkbox
        class="feedback-checkbox-option"
        [checked]="option.checked"
        (change)="onCheckboxChange($event, option)"
        ><div
          class="user-select-option-checkbox-text"
          [innerHTML]="option.message[currentLang]"
        ></div
      ></mat-checkbox>
    </ng-container>
  </div>
</ng-container>
